/* eslint-disable @typescript-eslint/no-explicit-any*/
import {
  CLEAN_UPLOAD_STATUS_CONDOMINIUMS,
  CONDOMINIUMS_LIST,
  CONDOMINIUMS_UPLOAD_LIST,
  CONDOMINIUMS_UPLOAD_STATUS,
  CONDOMINIUM_IS_LOGGED,
} from '../actions/actionTypes';

export const initialState: reducers.CondominiumsReducer = {
  list: [],
  count: 0,
  uploadLogList: [],
  uploadStatus: 0,
  isCondominiumLogged: false,
};

const condominiumsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case CONDOMINIUMS_LIST:
      return {
        ...state,
        list: action.payload.rows,
        count: action.payload.count,
      };

    case CONDOMINIUMS_UPLOAD_LIST:
      return {
        ...state,
        uploadLogList: action.payload.rows,
        logCount: action.payload.count,
      };

    case CONDOMINIUMS_UPLOAD_STATUS:
      return {
        ...state,
        uploadStatus: action.payload,
      };

    case CLEAN_UPLOAD_STATUS_CONDOMINIUMS:
      return {
        ...state,
        uploadStatus: 0,
      };

    case CONDOMINIUM_IS_LOGGED:
      return {
        ...state,
        isCondominiumLogged: action.payload,
      };

    default:
      return state;
  }
};

export default condominiumsReducer;
